import React from "react";

const fetchJson = async (url, headers) => {
    const res = await fetch(url, { next: { revalidate: 0 }, headers });
    if (!res.ok) throw new Error(`Failed fetch: ${url}`);
    return await res.json();
};

export const getPlayerData = async ({ baseUrl, sport, dataId, headers, dataType }) => {


    switch (dataType) {
        case "player-performance": {
            const leagues = await fetchJson(`${baseUrl}/${sport}/player/${dataId}/leagues`, headers);
            const firstLeagueId = leagues?.data?.[0]?.id;
            if (!firstLeagueId) throw new Error("No league ID found for player");
            const performance = await fetchJson(
                `${baseUrl}/${sport}/player/${dataId}/performance?leagueId=${firstLeagueId}`,
                headers
            );
            return { league: leagues, performance };
        }

        case "player-info": {
            const info = await fetchJson(
                `${baseUrl}/${sport}/player/${dataId}/info`,
                headers
            );
            return info;
        }

        case "player-history": {
            const history = await fetchJson(
                `${baseUrl}/${sport}/player/${dataId}/transfer`,
                headers
            );
            return history;
        }

        case "player": {
            let playerDetail;

            if (sport === "golf") {
                playerDetail = []
            } else {
                const detailType = sport === "tennis" ? "header" : "detail";
                playerDetail = await fetchJson(
                    `${baseUrl}/${sport}/player/${dataId}/${detailType}`,
                    headers
                );
            }

            return playerDetail;
        }

        // Cricket Player - Head (biography header with photo, name, role, etc.)
        case "cricket-player-head": {
            const playerHead = await fetchJson(
                `${baseUrl}/cricket/player/${dataId}/detail`,
                headers
            );
            return playerHead;
        }

        // Cricket Player - Info (overview, birthplace, education, teams)
        case "cricket-player-info": {
            const playerInfo = await fetchJson(
                `${baseUrl}/cricket/player/${dataId}/info`,
                headers
            );
            return playerInfo;
        }

        // Cricket Player - Stats (batting/bowling statistics)
        case "cricket-player-stats": {
            const playerStats = await fetchJson(
                `${baseUrl}/cricket/player/${dataId}/stats`,
                headers
            );
            return playerStats;
        }

        // Cricket Player - Matches (recent matches)
        case "cricket-player-matches": {
            const playerMatches = await fetchJson(
                `${baseUrl}/cricket/player/${dataId}/matches`,
                headers
            );
            return playerMatches;
        }

        default:
            return null;
    }
};
